import { useCaseApplication } from 'cases/shared/CaseApplicationContext';
import { RedSquigglyLine, RedSquigglySpace } from 'lib/Antd/Preview/RedSquigglyLine';
import { PanZoomContext } from 'lib/PanZoomElement/PanZoomElement';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { usePanel } from 'utils/panelContext';

const Span = styled.span`
  background-color: ${props => (props.isSelected ? '#c3daff' : '')};
  border: ${props => (props.isSelected ? '1px solid #4ba0f0' : 'none')};
  border-radius: 2px;
  padding: ${props => (props.isSelected ? '0 2px 0 2px' : '1px 0 1px 0')};
  margin: 0px;
  min-width: 30px;
  height: 22px;

  :hover {
    background-color: #c3daff;
    cursor: pointer;
  }
`;

export const Selectable = observer(({ itemKey, itemValue }) => {
  const application = useCaseApplication();
  const { step, panel } = usePanel();
  const panZoomContext = useContext(PanZoomContext);
  const { setActiveKey, activeKey, goToStep, setPanel } = application;
  const isValid = true;
  const isDisable = false;

  const handleOnKeyDown = e => {
    if (e.keyCode === 32 || e.keyCode === 13) {
      shouldGoto(e);
    }
  };

  const handleOnClick = e => {
    shouldGoto(e);
  };

  const shouldGoto = e => {
    if (e.type !== 'touchend') {
      if (panZoomContext.isDragging) {
        return;
      }
    }
    goToStep(step, false);
    setPanel(panel);
    setActiveKey(itemKey);
  };

  return isDisable ? (
    <span>{itemValue}</span>
  ) : (
    <Span
      tabIndex="0"
      onTouchEnd={handleOnClick}
      onKeyDown={handleOnKeyDown}
      onClick={handleOnClick}
      isSelected={activeKey === itemKey}
      data-testid={itemKey + 'SelectableText'}
      textLength={itemValue ? itemValue.length : 0}
    >
      {isValid ? itemValue : itemValue ? <RedSquigglyLine> {itemValue}</RedSquigglyLine> : <RedSquigglySpace />}
    </Span>
  );
});

Selectable.propTypes = {
  itemKey: PropTypes.string,
  itemValue: PropTypes.node
};
